module.exports = __webpack_public_path__ + "static/pricing-banner-de84377c00114dfa0e83fbf3e0f52def.svg";